module.exports = __webpack_public_path__ + "img/loader.48837098.gif";